import { Certificate as CertificateModel } from '@rocksoft/mdm-sdk-v2';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface Certificate extends CertificateModel {
  udid: string;
}

export type CertificateState = EntityState<Certificate>;

export function selectId(certificate: Certificate) {
  return certificate.udid;
}

export const adapter: EntityAdapter<Certificate> = createEntityAdapter<Certificate>({
  selectId,
});

export const initialState: CertificateState = adapter.getInitialState();
